import { TEAMS_RECEIVED } from '../actions/GetTeams';
import { TEAM_CREATED } from '../actions/CreateTeam';
import { TEAM_JOINED } from '../actions/JoinTeam';
import { PRODUCT_ADDED_TO_TEAM } from '../actions/product-management/AddProductToTeam';
import { TEAM_PRODUCTS_UPDATED } from '../actions/product-management/UpdateTeamProducts';
import { PRODUCT_PUBLISHED } from '../actions/product-management/PublishProduct';
import { TEAM_SWITCHED } from '../actions/SwitchTeams';

const initialState = {
  all: [],
  userTeams: [],
  currentTeam: null,
  loadingTeams: true,
};
let updatedTeam;

const teams = (state = initialState, action) => {
  switch (action.type) {
    case TEAMS_RECEIVED:
      return Object.assign({}, state, {
        all: action.all,
        userTeams: action.userTeams,
        currentTeam: action.currentTeam,
        loadingTeams: false,
      });
    case TEAM_CREATED:
      return {
        ...state,
        all: state.all.concat([action.team]),
        userTeams: state.userTeams.concat([action.team.id]),
      };
    case TEAM_JOINED:
      return {
        ...state,
        userTeams: state.userTeams.concat([action.teamId]),
      };
    case PRODUCT_ADDED_TO_TEAM:
      updatedTeam = {
        ...state.all.find(team => team.id == action.teamId)
      };

      updatedTeam.products = updatedTeam
        .products
        .filter(product => product.id !== action.product.id)
        .concat(action.product);

      return {
        ...state,
        all: state.all
          .filter(team => team.id !== action.teamId)
          .concat(updatedTeam),
      };
    case TEAM_PRODUCTS_UPDATED:
      updatedTeam = {
        ...state.all.find(team => team.id == action.teamId)
      };

      updatedTeam.products = action.products;

      return {
        ...state,
        all: state.all
          .filter(team => team.id !== action.teamId)
          .concat(updatedTeam),
      };
    case PRODUCT_PUBLISHED:
      const { product } = action.product;

      const all = state.all.map((team) => {
        const products = team.products.map((currentProduct) => {
          if (currentProduct.id === product.id) {
            return product;
          }

          return currentProduct;
        });

        return {
          ...team,
          products,
        };
      });

      return {
        ...state,
        all,
      };
      case TEAM_SWITCHED:
          return {
              ...state,
              currentTeam: action.teamId,
          };
  }

  return state;
};

export default teams;
